<template>
  <div id="main" role="document">
    <section id="info" class="container px-4 my-4">
      <div class="row">
        <div class="col-lg-12 px-lg-12 py-lg-12">
          <h1>Gruppo di lavoro</h1>
          <h5 class="my-4">
            Questo sito è stato realizzato dal gruppo di lavoro coordinato dalla
            <a target="_blank" href="https://www.unibo.it/sitoweb/monica.palmirani">prof.ssa Monica Palmirani</a> e così composto:
          </h5>
          <div class="d-flex align-items-center justify-content-start justify-content-md-around flex-wrap flex-sm-nowrap my-5">
            <div class="avatar-wrapper avatar-extra-text">
              <div class="avatar size-xl">
                <img src="static/team/monica.png" alt="Monica Palmirani">
              </div>
              <div class="extra-text">
                <h4><a target="_blank" href="https://www.unibo.it/sitoweb/monica.palmirani">Monica Palmirani</a></h4>
                <p>Professoressa Ordinaria in Informatica Giuridca</p>
              </div>
            </div>
            <div class="avatar-wrapper avatar-extra-text">
              <div class="avatar size-xl">
                <img src="static/team/luca.jpg" alt="Luca Cervone">
              </div>
              <div class="extra-text">
                <h4><a target="_blank" href="https://www.unibo.it/sitoweb/luca.cervone">Luca Cervone</a></h4>
                <p>Dottore di Ricerca in Informatica Giuridica</p>
              </div>
            </div>
            <div class="avatar-wrapper avatar-extra-text">
              <div class="avatar size-xl">
                <img src="static/team/octavian.jpeg" alt="Octavian Bujor">
              </div>
              <div class="extra-text">
                <h4><a target="_blank" href="https://www.linkedin.com/in/octavian-bujor-6b436790/">Octavian Bujor</a></h4>
                <p>Analista Programmatore Senior</p>
              </div>
            </div>
            <div class="avatar-wrapper avatar-extra-text">
              <div class="avatar size-xl">
                <img src="static/team/biagio.jpeg" alt="Biagio Distefano">
              </div>
              <div class="extra-text">
                <h4><a target="_blank" href="https://www.linkedin.com/in/bdles/?originalSubdomain=it">Biagio Distefano</a></h4>
                <p>Dottorando in Informatica Giuridica</p>
              </div>
            </div>
          </div>
          <div class="d-flex flow-row align-content-stretch flex-wrap flex-sm-nowrap">
            <div class="avatar-wrapper avatar-extra-text">
              <div class="avatar size-xl">
                <img src="static/team/francescod.jpeg" alt="Francesco Draicchio">
              </div>
              <div class="extra-text">
                <h4><a target="_blank" href="https://www.linkedin.com/in/francescodraicchio/?originalSubdomain=it">Francesco Draicchio</a></h4>
                <p>Analista Programmatore Senior</p>
              </div>
            </div>
            <div class="avatar-wrapper avatar-extra-text mx-md-3 mx-lg-3 mx-xs-0 mx-sm-0">
              <div class="avatar size-xl">
                <img src="static/team/francescos.png" alt="Francesco Sovrano">
              </div>
              <div class="extra-text">
                <h4><a target="_blank" href="https://www.unibo.it/sitoweb/francesco.sovrano2">Francesco Sovrano</a></h4>
                <p>Dottorando in Informatica</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'gruppo-di-lavoro',
  components: {
  },
  breadcrumb: {
    label: 'Gruppo di Lavoro',
    parent: 'home',
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
</style>






// WEBPACK FOOTER //
// src/components/pages/GruppoDiLavoro.vue